import React, { useEffect } from "react";
import { Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { OAuthProvider } from "@nestcoinco/hyper-api-gateway-api-client";

import "./StartAuthScreen.scss";
import PrimaryActionButton from "../../Buttons/PrimaryActionButton/PrimaryActionButton";
import { LINKS } from "../../../utils/constants";
import useAnalytics from "../../../hooks/useAnalytics";
import useAuth from "../../../hooks/useAuth";
import ImageGoogleIcon from "../../../images/google.svg";
import { CustomSpinner } from "../../CustomSpinner/CustomSpinner";
import GameThumbnailsHero from "../../GameThumbnailsHero/GameThumbnailsHero";

function StartAuthScreen() {
  const { t } = useTranslation("common");
  const { sendFirstOnboardingScreenEvent, sendContinueWithGoogleEvent } =
    useAnalytics();
  const { isAuthInProgress, handleAuthClick } = useAuth();

  useEffect(() => {
    sendFirstOnboardingScreenEvent();
  }, [sendFirstOnboardingScreenEvent]);

  return (
    <div className="start-auth-screen">
      <div className="position-relative modal-body">
        <GameThumbnailsHero />

        <div className="main-content">
          <Stack className="text-content">
            <p>
              {t("onboarding.play_100s_of_games")}
              {t("punctuations.full_stop")}
            </p>
            <p>
              {t("onboarding.no_installs")}
              {t("punctuations.full_stop")}
            </p>
            <p>
              {t("onboarding.no_ads")}
              {t("punctuations.full_stop")}
            </p>
          </Stack>
          <PrimaryActionButton
            size="lg"
            text={
              <>
                {t("onboarding.continue_with_google")}
                {isAuthInProgress ? <CustomSpinner size="sm" /> : null}
              </>
            }
            buttonClassName="authButton"
            leftImage={ImageGoogleIcon}
            onClick={() => {
              sendContinueWithGoogleEvent();
              handleAuthClick(OAuthProvider.GOOGLE);
            }}
          />

          <p className="disclaimer">
            {t("onboarding.by_continuing_you_agree")}{" "}
            <a
              href={LINKS.WEBPAGE.TERMS_AND_CONDITIONS}
              target="_blank"
              rel="noopener noreferrer"
              className="text-capitalize terms-and-privacy-link"
            >
              {t("onboarding.terms_and_conditions")}
            </a>{" "}
            {t("and")}{" "}
            <a
              href={LINKS.WEBPAGE.PRIVACY_POLICY}
              target="_blank"
              rel="noopener noreferrer"
              className="text-capitalize terms-and-privacy-link"
            >
              {t("onboarding.privacy_policy")}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default StartAuthScreen;
